export default __webpack_public_path__ + "static/media/about_img-1.2bc789dd.jpg";